import { atom, createStore } from "jotai"

import type { IUser } from "@aix/vidmax-shared/src/constants/prismaTypings"
import { isStaffEmail, isStaffUser } from "@aix/vidmax-shared/src/utils/staff"
export const superuserJotaiStore = createStore()
export const superuserJT = atom(true)

/** Same rule as the API (`isStaffUser`); isSuper-only users can hide admin UI via the superuser toggle. */
export const isAdminUserFE = (user?: IUser) => {
  if (!isStaffUser(user)) return false
  return isStaffEmail(user?.email) || superuserJotaiStore.get(superuserJT)
}
